export default "__VITE_ASSET__Dv4Q$yYT__"